import { render } from "./TranscriptionsDashboard.vue?vue&type=template&id=b8e51516&scoped=true"
import script from "./TranscriptionsDashboard.vue?vue&type=script&lang=js"
export * from "./TranscriptionsDashboard.vue?vue&type=script&lang=js"

import "./TranscriptionsDashboard.vue?vue&type=style&index=0&id=b8e51516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e51516"]])

export default __exports__